import { Chip, ChipProps } from '@mui/joy';

interface IProps extends ChipProps {
  value: string;
}

export const ColoredChip = ({ value, sx, ...props }: IProps) => {
  const color = getChipColor(value);

  const backgroundColor = getTint(color, 0.3);
  const textColor = darkenHex(color, 0.5);

  return (
    <Chip
      sx={{
        backgroundColor,
        color: textColor,
        borderRadius: '4px',
        ...sx,
      }}
      {...props}
    >
      {value}
    </Chip>
  );
};

const CHIP_COLORS = [
  '#F9A825', // yellow
  '#1976D2', // blue
  '#388E3C', // green
  '#D32F2F', // red
  '#7B1FA2', // purple
  '#0288D1', // cyan
  '#F57C00', // orange
  '#455A64', // slate
  '#C2185B', // pink
  '#0097A7', // teal
  '#AFB42B', // lime
  '#5D4037', // brown
  '#0288D1', // light blue
  '#FBC02D', // gold
  '#388E3C', // dark green
  '#1976D2', // dark blue
];

const getChipColor = (value: string) => {
  if (!value) {
    return '#000000';
  }

  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = value.charCodeAt(i) + ((hash << 5) - hash);
  }

  return CHIP_COLORS[Math.abs(hash) % CHIP_COLORS.length];
};

const hexToRgb = (hex: string) => {
  const match = hex.replace('#', '').match(/.{1,2}/g);
  if (!match) {
    return [0, 0, 0];
  }

  return match.map((x) => parseInt(x, 16));
};

const getTint = (hex: string, alpha = 0.12) => {
  const [r, g, b] = hexToRgb(hex);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const darkenHex = (hex: string, amount = 0.3) => {
  const [r, g, b] = hexToRgb(hex);

  const dr = Math.round(r * (1 - amount));
  const dg = Math.round(g * (1 - amount));
  const db = Math.round(b * (1 - amount));

  return `rgb(${dr}, ${dg}, ${db})`;
};
